"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _gbp = _interopRequireDefault(require("gbp"));
var _occasion = _interopRequireDefault(require("occasion"));
var _requireAuthentication = _interopRequireDefault(require("../require-authentication"));
var _table = _interopRequireDefault(require("../core/table"));
var _modal = _interopRequireDefault(require("../core/modal"));
var _button = _interopRequireDefault(require("../core/button"));
var _StripePaymentContainer = _interopRequireDefault(require("../core/StripePaymentContainer"));
var _StripeCheckoutForm = _interopRequireDefault(require("../core/StripeCheckoutForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("h1", null, "New Payment Details");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "All failed payments have been resolved");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Unfortunately, a recent charge to your card has failed; this may be because you have received a new card in the interim, or that additional authorisation is required. To retain your entries, please provide new payment details. The following competition entries will be updated with your new card details.");
var _ref4 = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header lead"
}, "New Payment Details");
class SubmitNewPayment extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      error: null
    });
    _defineProperty(this, "_onErrorDismissed", () => {
      this.setState({
        error: null
      });
    });
  }
  render() {
    const dismissErrorButton = /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onErrorDismissed
    }, "OK");
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !this.state.error ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: dismissErrorButton,
      onClose: this._onErrorDismissed
    }, this.state.error), _ref, !this.props.failedChargesforUser.length ? _ref2 : /*#__PURE__*/_react.default.createElement("div", null, _ref3, this.props.failedChargesforUser.map(charge => /*#__PURE__*/_react.default.createElement("div", {
      key: charge.id
    }, /*#__PURE__*/_react.default.createElement("h3", null, charge.competition.competitionName), /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("tbody", null, charge.entries.map(entry => /*#__PURE__*/_react.default.createElement("tr", {
      key: entry.id
    }, /*#__PURE__*/_react.default.createElement("td", null, entry.race.raceName), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(entry.race.competitionDay.dayDate, 'ddd D MMM')), /*#__PURE__*/_react.default.createElement("td", null, entry.bibNumber, " ", entry.bibName))))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Total Fees for ", charge.competition.competitionName, ": ", (0, _gbp.default)(charge.chargeAmount))))), /*#__PURE__*/_react.default.createElement(_StripeCheckoutForm.default, {
      style: {
        marginTop: 20
      },
      onCheckout: async ({
        paymentMethodID
      }) => {
        return await this.props.onPayFailedCharges(paymentMethodID, this.props.failedChargesforUser.map(ch => ch.id));
      },
      onCheckoutError: error => this.setState({
        error
      })
    }, ({
      checkoutInProgress
    }) => /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref4, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_StripePaymentContainer.default, {
      submitButtonLabel: "Confirm Update",
      loading: checkoutInProgress
    }))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref5 = {
  failedChargesforUser: {
    id: true,
    competition: {
      competitionName: true
    },
    chargeAmount: true,
    entries: {
      id: true,
      race: {
        raceName: true,
        competitionDay: {
          dayDate: true
        }
      },
      bibNumber: true,
      bibName: true
    }
  }
};
var _default = exports.default = (0, _requireAuthentication.default)((0, _reactBicycle.connect)(SubmitNewPayment, props => _ref5, (client, props) => ({
  onPayFailedCharges(token, chargeIDs) {
    return client.update('Charge.payFailedCharges', {
      token,
      chargeIDs
    });
  }
})));